import {Add} from "./BasketAB/Add";
import {Remove} from "./BasketAB/Remove";
import {AddCombo} from "./BasketAB/AddCombo";

export class Basket {
    constructor() {
        $('.js-basket_remove').off('click').on('click', function (event) {
            event.preventDefault();

            Basket.remove($(this))
        });
    }

    static add(id, callback = null, preloader = true) {
        return new Add(id, callback, preloader);
    }
    static add_combo(id, callback = null) {
        return new AddCombo(id, callback);
    }
    static remove(element) {
        return new Remove(element);
    }
    static getOffers(id) {
        return new Promise((resolve, reject) => {
            $.post('/ajax/basket/offers/', { id }, (result) => {
                if (!result || !result.hasOwnProperty('type')) {
                    reject(new Error('Некорректный ответ сервера'));
                    return;
                }

                if (result.type === 'success') {
                    resolve(result.value);
                } else {
                    reject(new Error(result.value || 'Неизвестная ошибка'));
                }
            }, 'json').fail(() => reject(new Error('Сетевая ошибка')));
        });
    }
}